import React from 'react'
import ReactDOM from 'react-dom'
import settings from './app/components/settings'
import Root from './app/components/root'
import App from './app'
import './polyfills'
import './styles/global.css'
import { appBasePath } from './utils/appBasePath'
import { WebsiteFormApp } from './app/components/website-form/WebsiteFormApp'

const renderWebsiteForm = (form) => {
  ReactDOM.render(
    <Root
      brand={settings.brand}
      basename={appBasePath}
    >
      <WebsiteFormApp
        serviceCode={form.dataset.serviceCode}
        serviceId={form.dataset.serviceId}
        storeId={form.dataset.storeId}
      />
    </Root>,
    form
  )
}

const renderApp = (root) => {
  ReactDOM.render(
    <Root
      brand={settings.brand}
      basename={appBasePath}
    >
      <App />
    </Root>,
    root
  )
}

const root = document.getElementById('root')
let form = document.getElementById('bada-form')
const queryForm = window.location.search.includes('bada-form')
if (form || queryForm) {
  if (!form) {
    form = document.createElement('div')
    form.dataset.serviceId = 100
    form.dataset.serviceCode = 'callback-request'
    document.body.appendChild(form)
  }
  renderWebsiteForm(form)

  // Hot Module Replacement API
  if (module.hot) {
    module.hot.accept('./app', renderWebsiteForm)
  }
} else if (root) {
  renderApp(root)

  // Hot Module Replacement API
  if (module.hot) {
    module.hot.accept('./app', renderApp)
  }
}

window.renderBadaWebsiteForm = renderWebsiteForm
